import React from "react";
import "./Skills.css";
import Zoom from "react-reveal/Zoom";
const Skills = () => {
  return (
    <section class="skills mb-5" id="skills">
      <h2 class="skill-title text-center" id="Skills">
        My skill<span style={{ color: "crimson" }}>s</span>
      </h2>
      <div class="skills-content row mr-0">
        <div class="column left col-md-5 ml-5">
          <Zoom top>
            <div class="text">My creative skills & experiences.</div>
            <p>
              Web developer skills refer to the specific abilities needed to get
              hired and successfully perform in a web developer role. Having
              these skills in abundance can help you stand out from other
              candidates vying for the same role and in your everyday tasks on
              the job. As with any job, you also have the ability to develop
              your skills as a web developer over time. Some web developer
              skills include understanding HTML, general design skills and being
              ana
            </p>
            <a href="#">Read more</a>
          </Zoom>
        </div>
        <div class="column right col-md-6">
          <div class="bars">
            <div class="info">
              <span>HTML</span>
              <span>90%</span>
            </div>
            <div class="line html"></div>
          </div>
          <div class="bars">
            <div class="info">
              <span>CSS</span>
              <span>70%</span>
            </div>
            <div class="line css"></div>
          </div>
          <div class="bars">
            <div class="info">
              <span>JavaScript</span>
              <span>80%</span>
            </div>
            <div class="line js"></div>
          </div>
          <div class="bars">
            <div class="info">
              <span>React</span>
              <span>85%</span>
            </div>
            <div class="line php"></div>
          </div>
          <div class="bars">
            <div class="info">
              <span>Nodejs</span>
              <span>50%</span>
            </div>
            <div class="line mysql"></div>
          </div>
          <div class="bars">
            <div class="info">
              <span>Express</span>
              <span>60%</span>
            </div>
            <div class="line node"></div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Skills;
